import { render, staticRenderFns } from "./ChatsTransfer.vue?vue&type=template&id=71f54f24&scoped=true&"
import script from "./ChatsTransfer.vue?vue&type=script&lang=js&"
export * from "./ChatsTransfer.vue?vue&type=script&lang=js&"
import style0 from "./ChatsTransfer.vue?vue&type=style&index=0&id=71f54f24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f54f24",
  null
  
)

export default component.exports